const AbstractCloverRequestRecord = require('@/lib/PaymentMethods/Clover/Records/Request/AbstractCloverRequestRecord');

class CloverTransactionCreditRequestRecord extends AbstractCloverRequestRecord {
    /**
     * @link https://docs.clover.com/reference/credit
     *
     * @param {number} amountInMinorUnits
     * @param {} deviceOptions
     */
    constructor(amountInMinorUnits, deviceOptions) {
        const url = '/connect/v1/credits';

        if (!amountInMinorUnits || !Number.isInteger(amountInMinorUnits)) {
            throw new Error('amountInMinorUnits is required');
        }

        let data = {
            // The api always expects a positive integer.
            amount: amountInMinorUnits,
            // @Todo This could include an array of cardEntryMethods and cardNotPresent.
            deviceOptions,
        };

        // Note: @see CloverAxiosInstance.js
        // We also use payment.thirdPartyId as the header: Idempotency-Key
        super(
            'POST',
            url
        );
        this.data = data;
    }
}

module.exports = CloverTransactionCreditRequestRecord;
